import classNames from "classnames";
import { ReactNode } from "react";

export type DescriptionProps = {
  label: ReactNode;
  value: ReactNode;
  className?: string;
};

export function Description({ label, value, className }: DescriptionProps) {
  return (
    <div className={classNames("grow", className)}>
      <dt className="font-bold text-black text dark:text-white">{label}</dt>
      <dd className="mt-1 text-sm text-gray-800 dark:text-gray-300 sm:mt-0 sm:col-span-2">
        {value}
      </dd>
    </div>
  );
}
